export const master = {
  sel_season: [
    {
      label: '上旬',
      value: 1,
    },
    {
      label: '中旬',
      value: 2,
    },
    {
      label: '下旬',
      value: 3,
    },
  ],
  sel_open_direct: [
    {
      label: '北',
      value: 1,
      athome: true,
    },
    {
      label: '北東',
      value: 2,
      athome: true,
    },
    {
      label: '東',
      value: 3,
      athome: true,
    },
    {
      label: '南東',
      value: 4,
      suumoSearchItem: true,
      athome: true,
    },
    {
      label: '南',
      value: 5,
      suumoSearchItem: true,
      athome: true,
    },
    {
      label: '南西',
      value: 6,
      suumoSearchItem: true,
      athome: true,
    },
    {
      label: '西',
      value: 7,
      athome: true,
    },
    {
      label: '北西',
      value: 8,
      athome: true,
    },
  ],
  sel_floor_cat: [
    {
      label: '地上',
      value: 1,
      template: '.t_s_sel_floor_cat1',
      athome: true,
    },
    {
      label: '地下',
      value: 2,
      template: '.t_s_sel_floor_cat2',
      athome: true,
    },
  ],
  vacancy_div: [
    {
      label: '空室',
      value: 2,
      template: '.t_s_vacancy_div2',
      athome: true,
    },
    {
      label: '在室',
      value: 1,
      template: '.t_s_vacancy_div1',
      athome: true,
    },
    {
      label: '退去予定',
      value: 3,
      template: '.t_s_vacancy_div3',
      athome: true,
    },
    {
      label: '建設中',
      value: 4,
      template: '.t_s_vacancy_div4',
      athome: true,
    },
  ],
  vacancy_div_clasmo: [
    {
      label: '空有',
      value: 2,
      template: '.t_s_vacancy_div2',
      athome: true,
    },
    {
      label: '空無',
      value: 1,
      template: '.t_s_vacancy_div1',
      athome: true,
    },
    {
      label: '退去予定',
      value: 3,
      template: '.t_s_vacancy_div3',
      athome: true,
    },
    {
      label: '建設中',
      value: 4,
      template: '.t_s_vacancy_div4',
      athome: true,
    },
  ],
  recruitment_judgment: [
    {
      label: '掲載可',
      value: 1,
      template: '.t_s_recruitment_judgment1',
    },
    {
      label: '掲載不可',
      value: 2,
      template: '.t_s_recruitment_judgment2',
    },
  ],
  sel_occupancy: [
    {
      label: '即日',
      value: 2,
      template: '.t_s_sel_occupancy2',
      suumoSearchItem: true,
      athome: true,
    },
    {
      label: '相談',
      value: 3,
      template: '.t_s_sel_occupancy3',
      athome: true,
    },
    {
      label: '期日指定',
      value: 1,
      template: '.t_s_sel_occupancy1',
      athome: true,
    },
  ],
  apply_agreement: [
    {
      label: '申込',
      value: 1,
      template: '.t_s_apply_agreement1',
    },
    {
      label: '成約',
      value: 2,
      template: '.t_s_apply_agreement2',
    },
  ],
  sel_cancel_announce: [
    {
      label: 'ヶ月前',
      value: 1,
      template: '.t_s_sel_cancel_announce1',
    },
    {
      label: '日前',
      value: 2,
      template: '.t_s_sel_cancel_announce2',
    },
  ],
  sel_ad: [
    {
      label: 'ヶ月',
      value: 1,
      template: '.t_s_sel_ad1',
    },
    {
      label: '円',
      value: 2,
      template: '.t_s_sel_ad2',
    },
  ],
  f_campaign: [
    {
      label: 'なし',
      value: 0,
    },
    {
      label: 'あり',
      value: 1,
    },
  ],
  f_campaign_deposit: [
    {
      label: '変更なし',
      value: 0,
    },
    {
      label: '変更あり',
      value: 1,
    },
  ],
  unit_campaign_deposit_expense: [
    {
      label: 'ヶ月',
      value: 1,
      template: '.t_s_unit_campaign_deposit1',
    },
    {
      label: '円',
      value: 2,
      template: '.t_s_unit_campaign_deposit2',
    },
  ],
  f_campaign_keymoney: [
    {
      label: '変更なし',
      value: 0,
    },
    {
      label: '変更あり',
      value: 1,
    },
  ],
  unit_campaign_keymoney_expense: [
    {
      label: 'ヶ月',
      value: 1,
      template: '.t_s_unit_campaign_keymoney1',
    },
    {
      label: '円',
      value: 2,
      template: '.t_s_unit_campaign_keymoney2',
    },
  ],
  f_campaign_ad: [
    {
      label: '変更なし',
      value: 0,
    },
    {
      label: '変更あり',
      value: 1,
    },
  ],
  unit_campaign_ad: [
    {
      label: 'ヶ月',
      value: 1,
      template: '.t_s_unit_campaign_ad1',
    },
    {
      label: '円',
      value: 2,
      template: '.t_s_unit_campaign_ad2',
    },
    {
      label: '%',
      value: 3,
      template: '.t_s_unit_campaign_ad3',
    },
  ],
  f_campaign_freerent: [
    {
      label: 'なし',
      value: 0,
    },
    {
      label: 'あり',
      value: 1,
    },
  ],
  rank: [
    {
      label: 'A',
      value: 'A',
      template: '.t_r_rankA',
    },
    {
      label: 'B',
      value: 'B',
      template: '.t_r_rankB',
    },
    {
      label: 'C',
      value: 'C',
      template: '.t_r_rankC',
    },
    {
      label: 'D',
      value: 'D',
      template: '.t_r_rankD',
    },
    {
      label: 'E',
      value: 'E',
      template: '.t_r_rankE',
    },
    {
      label: 'F',
      value: 'F',
      template: '.t_r_rankF',
    },
    {
      label: 'G',
      value: 'G',
      template: '.t_r_rankG',
    },
    {
      label: 'H',
      value: 'H',
      template: '.t_r_rankH',
    },
    {
      label: 'その他',
      value: 'その他',
      template: '.t_r_rankその他',
    },
  ],
  sel_general: [
    {
      label: '管理費',
      value: 1,
      template: '.t_s_sel_general1',
    },
    {
      label: '共益費',
      value: 2,
      template: '.t_s_sel_general2',
    },
  ],
  sel_general_expense: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_sel_general_expense1',
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_sel_general_expense2',
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_sel_general_expense3',
    },
  ],
  sel_deposit: [
    {
      label: '敷金',
      value: 1,
      template: '.t_s_sel_deposit1',
      athome: true,
    },
    {
      label: '保証金',
      value: 2,
      template: '.t_s_sel_deposit2',
      athome: true,
    },
  ],
  unit_deposit: [
    {
      label: 'ヶ月',
      value: 1,
    },
    {
      label: '円',
      value: 2,
    },
  ],
  unit_deposit_button: [
    {
      label: '0ヶ月',
      value: 0,
      unitValue: 1,
      template: '.t_s_unit_deopsit0',
      athome: true,
    },
    {
      label: '1ヶ月',
      value: 1,
      unitValue: 1,
      template: '.t_s_unit_deopsit1',
      athome: true,
    },
    {
      label: '2ヶ月',
      value: 2,
      unitValue: 1,
      template: '.t_s_unit_deopsit2',
      athome: true,
    },
    {
      label: '3ヶ月',
      value: 3,
      unitValue: 1,
      template: '.t_s_unit_deopsit3',
      athome: true,
    },
    {
      label: '円',
      value: null,
      unitValue: 2,
      template: '.t_s_unit_deposit',
      athome: true,
    },
  ],
  unit_keymoney_expense: [
    {
      label: 'ヶ月',
      value: 1,
    },
    {
      label: '円',
      value: 2,
    },
  ],
  unit_keymoney_expense_button: [
    {
      label: '0ヶ月',
      value: 0,
      unitValue: 1,
      template: '.t_e_unit_keymoney_expense0',
      athome: true,
    },
    {
      label: '1ヶ月',
      value: 1,
      unitValue: 1,
      template: '.t_e_unit_keymoney_expense1',
      athome: true,
    },
    {
      label: '2ヶ月',
      value: 2,
      unitValue: 1,
      template: '.t_e_unit_keymoney_expense2',
      athome: true,
    },
    {
      label: '3ヶ月',
      value: 3,
      unitValue: 1,
      template: '.t_e_unit_keymoney_expense3',
      athome: true,
    },
    {
      label: '円',
      value: null,
      unitValue: 2,
      template: '.t_e_unit_keymoney_expense',
      athome: true,
    },
  ],
  unit_pet_keymoney_expense: [
    {
      label: 'ヶ月',
      value: 1,
    },
    {
      label: '円',
      value: 2,
    },
  ],
  sel_freerent_class: [
    {
      label: '家賃',
      value: 1,
    },
    {
      label: '家賃＋管理/共益費',
      value: 2,
    },
  ],
  unit_depositinc_expense: [
    {
      label: 'ヶ月',
      value: 1,
      template: '.t_s_unit_depositinc_expense1',
    },
    {
      label: '万円',
      value: 2,
      template: '.t_s_unit_depositinc_expense2',
    },
  ],
  sel_repayment_expense: [
    {
      label: '償却',
      value: 1,
      template: '.t_s_sel_repayment_expense1',
      athome: true,
    },
    {
      label: '敷引',
      value: 2,
      template: '.t_s_sel_repayment_expense2',
      athome: true,
    },
  ],
  unit_repayment_expense: [
    {
      label: 'ヶ月',
      value: 1,
      template: '.t_s_unit_repayment_expense1',
      athome: true,
    },
    {
      label: '円',
      value: 2,
      template: '.t_s_unit_repayment_expense2',
      athome: true,
    },
    {
      label: '%',
      value: 3,
      template: '.t_s_unit_repayment_expense3',
      athome: true,
    },
    {
      label: '実費',
      value: 4,
      template: '.t_s_unit_repayment_expense4',
      athome: true,
    },
  ],
  repayment_period: [
    {
      label: '退去時',
      value: 1,
      template: '.t_s_repayment_period1',
    },
    {
      label: '毎年',
      value: 2,
      template: '.t_s_repayment_period2',
    },
    {
      label: '更新時',
      value: 3,
      template: '.t_s_repayment_period3',
    },
  ],
  tax_key_change: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_key_change1',
      athome: true,
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_key_change2',
      athome: true,
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_key_change3',
      athome: true,
    },
  ],
  tax_house_cleaning: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_house_cleaning1',
      athome: true,
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_house_cleaning2',
      athome: true,
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_house_cleaning3',
      athome: true,
    },
  ],
  period_house_cleaning: [
    {
      label: '入居時',
      value: 1,
      template: '.t_s_period_house_cleaning1',
      athome: true,
    },
    {
      label: '退去時',
      value: 2,
      template: '.t_s_period_house_cleaning2',
      athome: true,
    },
    {
      label: '月額',
      value: 3,
      template: '.t_s_period_house_cleaning3',
      athome: true,
    },
    {
      label: '年額',
      value: 4,
      template: '.t_s_period_house_cleaning4',
      athome: true,
    },
  ],
  tax_heating_maintenance: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_heating_maintenance1',
      athome: true,
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_heating_maintenance2',
      athome: true,
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_heating_maintenance3',
      athome: true,
    },
  ],
  period_heating_maintenance: [
    {
      label: '入居時',
      value: 1,
      template: '.t_s_period_heating_maintenance1',
      athome: true,
    },
    {
      label: '退去時',
      value: 2,
      template: '.t_s_period_heating_maintenance2',
      athome: true,
    },
    {
      label: '月額',
      value: 3,
      template: '.t_s_period_heating_maintenance3',
      athome: true,
    },
    {
      label: '年額',
      value: 4,
      template: '.t_s_period_heating_maintenance4',
      athome: true,
    },
  ],
  tax_contract_renewal: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_contract_renewal1',
      athome: true,
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_contract_renewal2',
      athome: true,
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_contract_renewal3',
      athome: true,
    },
  ],
  period_contract_renewal: [
    {
      label: '入居時',
      value: 1,
      template: '.t_s_period_contract_renewal1',
      athome: true,
    },
    {
      label: '退去時',
      value: 2,
      template: '.t_s_period_contract_renewal2',
      athome: true,
    },
    {
      label: '月額',
      value: 3,
      template: '.t_s_period_contract_renewal3',
      athome: true,
    },
    {
      label: '年額',
      value: 4,
      template: '.t_s_period_contract_renewal4',
      athome: true,
    },
  ],
  tax_certificate_issuance: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_certificate_issuance1',
      athome: true,
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_certificate_issuance2',
      athome: true,
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_certificate_issuance3',
      athome: true,
    },
  ],
  period_certificate_issuance: [
    {
      label: '入居時',
      value: 1,
      template: '.t_s_period_certificate_issuance1',
      athome: true,
    },
    {
      label: '退去時',
      value: 2,
      template: '.t_s_period_certificate_issuance2',
      athome: true,
    },
    {
      label: '月額',
      value: 3,
      template: '.t_s_period_certificate_issuance3',
      athome: true,
    },
    {
      label: '年額',
      value: 4,
      template: '.t_s_period_certificate_issuance4',
      athome: true,
    },
  ],
  tax_pet_deodorant: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_pet_deodorant1',
      athome: true,
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_pet_deodorant2',
      athome: true,
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_pet_deodorant3',
      athome: true,
    },
  ],
  period_pet_deodorant: [
    {
      label: '入居時',
      value: 1,
      template: '.t_s_period_pet_deodorant1',
      athome: true,
    },
    {
      label: '退去時',
      value: 2,
      template: '.t_s_period_pet_deodorant2',
      athome: true,
    },
    {
      label: '月額',
      value: 3,
      template: '.t_s_period_pet_deodorant3',
      athome: true,
    },
    {
      label: '年額',
      value: 4,
      template: '.t_s_period_pet_deodorant4',
      athome: true,
    },
  ],
  sel_water_bill: [
    {
      label: '賃料に込',
      value: 1,
      template: '.t_s_sel_water_bill1',
    },
    {
      label: '実費',
      value: 2,
      template: '.t_s_sel_water_bill2',
    },
    {
      label: '実費頭割り',
      value: 3,
      template: '.t_s_sel_water_bill3',
    },
  ],
  tax_water_supply: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_water_supply1',
      athome: true,
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_water_supply2',
      athome: true,
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_water_supply3',
      athome: true,
    },
  ],
  period_water_supply: [
    {
      label: '入居時',
      value: 1,
      template: '.t_s_period_water_supply1',
      athome: true,
    },
    {
      label: '退去時',
      value: 2,
      template: '.t_s_period_water_supply2',
      athome: true,
    },
    {
      label: '月額',
      value: 3,
      template: '.t_s_period_water_supply3',
      athome: true,
    },
    {
      label: '年額',
      value: 4,
      template: '.t_s_period_water_supply4',
      athome: true,
    },
  ],
  tax_neighborhood_association: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_neighborhood_association1',
      athome: true,
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_neighborhood_association2',
      athome: true,
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_neighborhood_association3',
      athome: true,
    },
  ],
  period_neighborhood_association: [
    {
      label: '入居時',
      value: 1,
      template: '.t_s_period_neighborhood_association1',
      athome: true,
    },
    {
      label: '退去時',
      value: 2,
      template: '.t_s_period_neighborhood_association2',
      athome: true,
    },
    {
      label: '月額',
      value: 3,
      template: '.t_s_period_neighborhood_association3',
      athome: true,
    },
    {
      label: '年額',
      value: 4,
      template: '.t_s_period_neighborhood_association4',
      athome: true,
    },
  ],
  tax_settlement_service: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_settlement_service1',
      athome: true,
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_settlement_service2',
      athome: true,
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_settlement_service3',
      athome: true,
    },
  ],
  period_settlement_service: [
    {
      label: '入居時',
      value: 1,
      template: '.t_s_period_settlement_service1',
      athome: true,
    },
    {
      label: '退去時',
      value: 2,
      template: '.t_s_period_settlement_service2',
      athome: true,
    },
    {
      label: '月額',
      value: 3,
      template: '.t_s_period_settlement_service3',
      athome: true,
    },
    {
      label: '年額',
      value: 4,
      template: '.t_s_period_settlement_service4',
      athome: true,
    },
  ],
  tax_kerosenestove_cleaning: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_kerosenestove_cleaning1',
      athome: true,
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_kerosenestove_cleaning2',
      athome: true,
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_kerosenestove_cleaning3',
      athome: true,
    },
  ],
  period_kerosenestove_cleaning: [
    {
      label: '入居時',
      value: 1,
      template: '.t_s_period_kerosenestove_cleaning1',
      athome: true,
    },
    {
      label: '退去時',
      value: 2,
      template: '.t_s_period_kerosenestove_cleaning2',
      athome: true,
    },
    {
      label: '月額',
      value: 3,
      template: '.t_s_period_kerosenestove_cleaning3',
      athome: true,
    },
    {
      label: '年額',
      value: 4,
      template: '.t_s_period_kerosenestove_cleaning4',
      athome: true,
    },
  ],
  tax_airconditioner_cleaning: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_airconditioner_cleaning1',
      athome: true,
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_airconditioner_cleaning2',
      athome: true,
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_airconditioner_cleaning3',
      athome: true,
    },
  ],
  period_airconditioner_cleaning: [
    {
      label: '入居時',
      value: 1,
      template: '.t_s_period_airconditioner_cleaning1',
      athome: true,
    },
    {
      label: '退去時',
      value: 2,
      template: '.t_s_period_airconditioner_cleaning2',
      athome: true,
    },
    {
      label: '月額',
      value: 3,
      template: '.t_s_period_airconditioner_cleaning3',
      athome: true,
    },
    {
      label: '年額',
      value: 4,
      template: '.t_s_period_airconditioner_cleaning4',
      athome: true,
    },
  ],
  tax_24hour_administration: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_24hour_administration1',
      athome: true,
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_24hour_administration2',
      athome: true,
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_24hour_administration3',
      athome: true,
    },
  ],
  period_24hour_administration: [
    {
      label: '入居時',
      value: 1,
      template: '.t_s_period_24hour_administration1',
      athome: true,
    },
    {
      label: '退去時',
      value: 2,
      template: '.t_s_period_24hour_administration2',
      athome: true,
    },
    {
      label: '月額',
      value: 3,
      template: '.t_s_period_24hour_administration3',
      athome: true,
    },
    {
      label: '年額',
      value: 4,
      template: '.t_s_period_24hour_administration4',
      athome: true,
    },
  ],
  tax_maintenance_costs: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_maintenance_costs1',
      athome: true,
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_maintenance_costs2',
      athome: true,
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_maintenance_costs3',
      athome: true,
    },
  ],
  period_maintenance_costs: [
    {
      label: '入居時',
      value: 1,
      template: '.t_s_period_maintenance_costs1',
      athome: true,
    },
    {
      label: '退去時',
      value: 2,
      template: '.t_s_period_maintenance_costs2',
      athome: true,
    },
    {
      label: '月額',
      value: 3,
      template: '.t_s_period_maintenance_costs3',
      athome: true,
    },
    {
      label: '年額',
      value: 4,
      template: '.t_s_period_maintenance_costs4',
      athome: true,
    },
  ],
  tax_miscellaneous_expense: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_miscellaneous_expense1',
      athome: true,
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_miscellaneous_expense2',
      athome: true,
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_miscellaneous_expense3',
      athome: true,
    },
  ],
  period_miscellaneous_expense: [
    {
      label: '入居時',
      value: 1,
      template: '.t_s_period_miscellaneous_expense1',
      athome: true,
    },
    {
      label: '退去時',
      value: 2,
      template: '.t_s_period_miscellaneous_expense2',
      athome: true,
    },
    {
      label: '月額',
      value: 3,
      template: '.t_s_period_miscellaneous_expense3',
      athome: true,
    },
    {
      label: '年額',
      value: 4,
      template: '.t_s_period_miscellaneous_expense4',
      athome: true,
    },
  ],
  tax_trunk_room: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_trunk_room1',
      athome: true,
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_trunk_room2',
      athome: true,
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_trunk_room3',
      athome: true,
    },
  ],
  period_trunk_room: [
    {
      label: '入居時',
      value: 1,
      template: '.t_s_period_trunk_room1',
      athome: true,
    },
    {
      label: '退去時',
      value: 2,
      template: '.t_s_period_trunk_room2',
      athome: true,
    },
    {
      label: '月額',
      value: 3,
      template: '.t_s_period_trunk_room3',
      athome: true,
    },
    {
      label: '年額',
      value: 4,
      template: '.t_s_period_trunk_room4',
      athome: true,
    },
  ],
  tax_else_price1: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_else_price11',
      athome: true,
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_else_price12',
      athome: true,
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_else_price13',
      athome: true,
    },
  ],
  else_price1_period: [
    {
      label: '入居時',
      value: 1,
      template: '.t_s_else_price1_period1',
      athome: true,
    },
    {
      label: '更新時',
      value: 5,
      template: '.t_s_else_price1_period5',
      athome: true,
    },
    {
      label: '退去時',
      value: 2,
      template: '.t_s_else_price1_period2',
      athome: true,
    },
    {
      label: '月額',
      value: 3,
      template: '.t_s_else_price1_period3',
      athome: true,
    },
    {
      label: '年額',
      value: 4,
      template: '.t_s_else_price1_period4',
      athome: true,
    },
  ],
  tax_else_price2: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_else_price21',
      athome: true,
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_else_price22',
      athome: true,
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_else_price23',
      athome: true,
    },
  ],

  else_price2_period: [
    {
      label: '入居時',
      value: 1,
      template: '.t_s_else_price2_period1',
      athome: true,
    },
    {
      label: '更新時',
      value: 5,
      template: '.t_s_else_price2_period5',
      athome: true,
    },
    {
      label: '退去時',
      value: 2,
      template: '.t_s_else_price2_period2',
      athome: true,
    },
    {
      label: '月額',
      value: 3,
      template: '.t_s_else_price2_period3',
      athome: true,
    },
    {
      label: '年額',
      value: 4,
      template: '.t_s_else_price2_period4',
      athome: true,
    },
  ],
  tax_else_price3: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_else_price31',
      athome: true,
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_else_price32',
      athome: true,
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_else_price33',
      athome: true,
    },
  ],

  else_price3_period: [
    {
      label: '入居時',
      value: 1,
      template: '.t_s_else_price3_period1',
      athome: true,
    },
    {
      label: '更新時',
      value: 5,
      template: '.t_s_else_price3_period5',
      athome: true,
    },
    {
      label: '退去時',
      value: 2,
      template: '.t_s_else_price3_period2',
      athome: true,
    },
    {
      label: '月額',
      value: 3,
      template: '.t_s_else_price3_period3',
      athome: true,
    },
    {
      label: '年額',
      value: 4,
      template: '.t_s_else_price3_period4',
      athome: true,
    },
  ],
  tax_else_price4: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_else_price41',
      athome: true,
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_else_price42',
      athome: true,
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_else_price43',
      athome: true,
    },
  ],

  else_price4_period: [
    {
      label: '入居時',
      value: 1,
      template: '.t_s_else_price4_period1',
      athome: true,
    },
    {
      label: '更新時',
      value: 5,
      template: '.t_s_else_price4_period5',
      athome: true,
    },
    {
      label: '退去時',
      value: 2,
      template: '.t_s_else_price4_period2',
      athome: true,
    },
    {
      label: '月額',
      value: 3,
      template: '.t_s_else_price4_period3',
      athome: true,
    },
    {
      label: '年額',
      value: 4,
      template: '.t_s_else_price4_period4',
      athome: true,
    },
  ],
  tax_else_price5: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_else_price51',
      athome: true,
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_else_price52',
      athome: true,
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_else_price53',
      athome: true,
    },
  ],

  else_price5_period: [
    {
      label: '入居時',
      value: 1,
      template: '.t_s_else_price5_period1',
      athome: true,
    },
    {
      label: '更新時',
      value: 5,
      template: '.t_s_else_price5_period5',
      athome: true,
    },
    {
      label: '退去時',
      value: 2,
      template: '.t_s_else_price5_period2',
      athome: true,
    },
    {
      label: '月額',
      value: 3,
      template: '.t_s_else_price5_period3',
      athome: true,
    },
    {
      label: '年額',
      value: 4,
      template: '.t_s_else_price5_period4',
      athome: true,
    },
  ],

  tax_else_price6: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_else_price61',
      athome: true,
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_else_price62',
      athome: true,
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_else_price63',
      athome: true,
    },
  ],

  else_price6_period: [
    {
      label: '入居時',
      value: 1,
      template: '.t_s_else_price6_period1',
      athome: true,
    },
    {
      label: '更新時',
      value: 5,
      template: '.t_s_else_price6_period5',
      athome: true,
    },
    {
      label: '退去時',
      value: 2,
      template: '.t_s_else_price6_period2',
      athome: true,
    },
    {
      label: '月額',
      value: 3,
      template: '.t_s_else_price6_period3',
      athome: true,
    },
    {
      label: '年額',
      value: 4,
      template: '.t_s_else_price6_period4',
      athome: true,
    },
  ],

  tax_else_price7: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_else_price71',
      athome: true,
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_else_price72',
      athome: true,
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_else_price73',
      athome: true,
    },
  ],

  else_price7_period: [
    {
      label: '入居時',
      value: 1,
      template: '.t_s_else_price7_period1',
      athome: true,
    },
    {
      label: '更新時',
      value: 5,
      template: '.t_s_else_price7_period5',
      athome: true,
    },
    {
      label: '退去時',
      value: 2,
      template: '.t_s_else_price7_period2',
      athome: true,
    },
    {
      label: '月額',
      value: 3,
      template: '.t_s_else_price7_period3',
      athome: true,
    },
    {
      label: '年額',
      value: 4,
      template: '.t_s_else_price7_period4',
      athome: true,
    },
  ],

  tax_else_price8: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_else_price81',
      athome: true,
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_else_price82',
      athome: true,
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_else_price83',
      athome: true,
    },
  ],

  else_price8_period: [
    {
      label: '入居時',
      value: 1,
      template: '.t_s_else_price8_period1',
      athome: true,
    },
    {
      label: '更新時',
      value: 5,
      template: '.t_s_else_price8_period5',
      athome: true,
    },
    {
      label: '退去時',
      value: 2,
      template: '.t_s_else_price8_period2',
      athome: true,
    },
    {
      label: '月額',
      value: 3,
      template: '.t_s_else_price8_period3',
      athome: true,
    },
    {
      label: '年額',
      value: 4,
      template: '.t_s_else_price8_period4',
      athome: true,
    },
  ],
  unit_brokerage_fee: [
    {
      label: 'ヶ月',
      value: 1,
    },
    {
      label: '円',
      value: 2,
    },
  ],
  unit_brokerage_fee_button: [
    {
      label: '0.55ヶ月',
      value: 0.55,
      unitValue: 1,
      template: '.t_s_unit_brokerage_feehalf',
      athome: true,
    },
    {
      label: '1.1ヶ月',
      value: 1.1,
      unitValue: 1,
      template: '.t_s_unit_brokerage_feefull',
      athome: true,
    },
    {
      label: 'ヶ月',
      value: null,
      unitValue: 1,
      template: '.t_s_unit_brokerage_fee1',
      athome: true,
    },
    {
      label: '円',
      value: null,
      unitValue: 2,
      template: '.t_s_unit_brokerage_fee2',
      athome: true,
    },
  ],
  tax_brokerage_fee: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_brokerage_fee1',
      athome: true,
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_brokerage_fee2',
      athome: true,
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_brokerage_fee3',
      athome: true,
    },
  ],
  credit_card_payment: [
    {
      label: '家賃',
      value: 1,
      template: '.t_s_credit_card_payment1',
      athome: true,
    },
    {
      label: '初期費用',
      value: 2,
      template: '.t_s_credit_card_payment2',
      athome: true,
    },
    {
      label: '家賃・初期費用',
      value: 3,
      template: '.t_s_credit_card_payment3',
      athome: true,
    },
  ],
  sel_contract: [
    {
      label: 'なし',
      value: 1,
      template: '.t_s_sel_contract1',
    },
    {
      label: '普通契約',
      value: 2,
      template: '.t_s_sel_contract2',
      athome: true,
    },
    {
      label: '定借契約',
      value: 3,
      template: '.t_s_sel_contract3',
      athome: true,
    },
  ],
  sel_contract_period: [
    {
      label: '更新可',
      value: 1,
      template: '.t_s_sel_contract_period1',
    },
    {
      label: '更新不可',
      value: 2,
      template: '.t_s_sel_contract_period2',
    },
    {
      label: '条件付更新可',
      value: 3,
      template: '.t_s_sel_contract_period3',
    },
    {
      label: '再契約可',
      value: 4,
      template: '.t_s_sel_contract_period4',
    },
    {
      label: '再契約不可',
      value: 5,
      template: '.t_s_sel_contract_period5',
    },
  ],
  f_renewal: [
    {
      label: '有',
      value: 1,
      template: '.t_r_f_renewal1',
    },
    {
      label: '無',
      value: 0,
      template: '.t_r_f_renewal0',
    },
  ],
  unit_renewal_fee: [
    {
      label: 'ヶ月（新賃料）',
      value: 1,
    },
    {
      label: '円',
      value: 2,
    },
  ],
  unit_renewal_fee_button: [
    {
      label: '1ヶ月',
      value: 1,
      unitValue: 1,
      template: '.t_s_unit_renewal_fee1',
      athome: true,
    },
    {
      label: '2ヶ月',
      value: 2,
      unitValue: 1,
      template: '.t_s_unit_renewal_fee2',
      athome: true,
    },
    {
      label: '円',
      value: null,
      unitValue: 2,
      template: '.t_s_unit_renewal_fee',
      athome: true,
    },
  ],
  unit_renewal_commission: [
    {
      label: 'ヶ月',
      value: 1,
      template: '.t_s_unit_renewal_commission1',
    },
    {
      label: '円',
      value: 2,
      template: '.t_s_unit_renewal_commission2',
    },
  ],
  tax_renewal_commission: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_renewal_commission1',
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_renewal_commission2',
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_renewal_commission3',
    },
  ],
  unit_renewal_commission_business_expense: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_unit_renewal_commission_business_expense1',
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_unit_renewal_commission_business_expense2',
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_unit_renewal_commission_business_expense3',
    },
  ],
  tax_parking_expense: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_parking_expense1',
      athome: true,
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_parking_expense2',
      athome: true,
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_parking_expense3',
      athome: true,
    },
  ],
  parking_deposit_expense_type: [
    {
      label: 'ヶ月',
      value: 1,
    },
    {
      label: '円',
      value: 2,
    },
  ],
  parking_deposit_expense_type_button: [
    {
      label: '1ヶ月',
      value: 1,
      unitValue: 1,
      template: '.t_s_parking_deposit_expense_type1',
    },
    {
      label: '2ヶ月',
      value: 2,
      unitValue: 1,
      template: '.t_s_parking_deposit_expense_type2',
    },
    {
      label: '円',
      value: null,
      unitValue: 2,
      template: '.t_s_parking_deposit_expense_type',
    },
  ],
  parking_keymoney_expense_type: [
    {
      label: 'ヶ月',
      value: 1,
    },
    {
      label: '円',
      value: 2,
    },
  ],
  parking_keymoney_expense_type_button: [
    {
      label: '1ヶ月',
      value: 1,
      unitValue: 1,
      template: '.t_s_parking_keymoney_expense_type1',
    },
    {
      label: '2ヶ月',
      value: 2,
      unitValue: 1,
      template: '.t_s_parking_keymoney_expense_type2',
    },
    {
      label: '円',
      value: null,
      unitValue: 2,
      template: '.t_s_parking_keymoney_expense_type',
    },
  ],
  sel_parking_contract_type: [
    {
      label: '駐車場契約必須(賃料・価格・管理費に含む)',
      value: 1,
      template: '.t_s_sel_parking_contract_type1',
    },
    {
      label: '駐車場契約必須（駐車場料金別)',
      value: 2,
      template: '.t_s_sel_parking_contract_type2',
    },
  ],
  tax_parking2_expense: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_parking2_expense1',
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_parking2_expense2',
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_parking2_expense3',
    },
  ],
  parking2_deposit_expense_type: [
    {
      label: 'ヶ月',
      value: 1,
    },
    {
      label: '円',
      value: 2,
    },
  ],
  parking2_deposit_expense_type_button: [
    {
      label: '1ヶ月',
      value: 1,
      unitValue: 1,
      template: '.t_s_parking2_deposit_expense_type1',
    },
    {
      label: '2ヶ月',
      value: 2,
      unitValue: 1,
      template: '.t_s_parking2_deposit_expense_type2',
    },
    {
      label: '円',
      value: null,
      unitValue: 2,
      template: '.t_s_parking2_deposit_expense_type',
    },
  ],
  parking2_keymoney_expense_type: [
    {
      label: 'ヶ月',
      value: 1,
    },
    {
      label: '円',
      value: 2,
    },
  ],
  parking2_keymoney_expense_type_button: [
    {
      label: '1ヶ月',
      value: 1,
      unitValue: 1,
      template: '.t_s_parking2_keymoney_expense_type1',
    },
    {
      label: '2ヶ月',
      value: 2,
      unitValue: 1,
      template: '.t_s_parking2_keymoney_expense_type2',
    },
    {
      label: '円',
      value: null,
      unitValue: 2,
      template: '.t_s_parking2_keymoney_expense_type3',
    },
  ],
  sel_parking2_contract_type: [
    {
      label: '駐車場契約必須(賃料・価格・管理費に含む)',
      value: 1,
      template: '.t_s_sel_parking2_contract_type1',
    },
    {
      label: '駐車場契約必須（駐車場料金別)',
      value: 2,
      template: '.t_s_sel_parking2_contract_type2',
    },
  ],
  tax_parking3_expense: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_parking3_expense1',
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_parking3_expense2',
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_parking3_expense3',
    },
  ],
  parking3_deposit_expense_type: [
    {
      label: 'ヶ月',
      value: 1,
    },
    {
      label: '円',
      value: 2,
    },
  ],
  parking3_deposit_expense_type_button: [
    {
      label: '1ヶ月',
      value: 1,
      unitValue: 1,
      template: '.t_s_parking3_deposit_expense_type1',
    },
    {
      label: '2ヶ月',
      value: 2,
      unitValue: 1,
      template: '.t_s_parking3_deposit_expense_type2',
    },
    {
      label: '円',
      value: null,
      unitValue: 2,
      template: '.t_s_parking3_deposit_expense_type',
    },
  ],
  parking3_keymoney_expense_type: [
    {
      label: 'ヶ月',
      value: 1,
    },
    {
      label: '円',
      value: 2,
    },
  ],
  parking3_keymoney_expense_type_button: [
    {
      label: '1ヶ月',
      value: 1,
      unitValue: 1,
      template: '.t_s_parking3_keymoney_expense_type1',
    },
    {
      label: '2ヶ月',
      value: 2,
      unitValue: 1,
      template: '.t_s_parking3_keymoney_expense_type2',
    },
    {
      label: '円',
      value: null,
      unitValue: 2,
      template: '.t_s_parking3_keymoney_expense_type3',
    },
  ],
  sel_parking3_contract_type: [
    {
      label: '駐車場契約必須(賃料・価格・管理費に含む)',
      value: 1,
      template: '.t_s_sel_parking3_contract_type1',
    },
    {
      label: '駐車場契約必須（駐車場料金別)',
      value: 2,
      template: '.t_s_sel_parking3_contract_type2',
    },
  ],
  sel_guarantor: [
    {
      label: '指定しない',
      value: 1,
      template: '.t_s_sel_guarantor1',
    },
    {
      label: '要',
      value: 2,
      template: '.t_s_sel_guarantor2',
    },
    {
      label: '不要',
      value: 3,
      template: '.t_s_sel_guarantor3',
      suumoSearchItem: true,
    },
  ],
  join_type: [
    {
      label: '任意加入',
      value: 1,
      template: '.t_r_join_type1',
    },
    {
      label: '必加入',
      value: 2,
      template: '.t_r_join_type3',
    },
  ],
  sel_waranty_fee1_unit: [
    {
      label: '円',
      value: 1,
      template: '.t_s_sel_waranty_fee1_unit1',
      athome: true,
    },
    {
      label: 'ヶ月',
      value: 2,
      template: '.t_s_sel_waranty_fee1_unit2',
      athome: true,
    },
    {
      label: '%',
      value: 3,
      template: '.t_s_sel_waranty_fee1_unit3',
      athome: true,
    },
  ],

  tax_waranty_fee1: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_waranty_fee1_1',
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_waranty_fee1_2',
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_waranty_fee1_3',
    },
  ],
  sel_waranty_fee2_unit: [
    {
      label: '円',
      value: 1,
      template: '.t_s_sel_waranty_fee2_unit1',
      athome: true,
    },
    {
      label: 'ヶ月',
      value: 2,
      template: '.t_s_sel_waranty_fee2_unit2',
      athome: true,
    },
    {
      label: '%',
      value: 3,
      template: '.t_s_sel_waranty_fee2_unit3',
      athome: true,
    },
  ],
  tax_waranty_fee2: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_waranty_fee2_1',
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_waranty_fee2_2',
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_waranty_fee2_3',
    },
  ],
  sel_waranty_fee3_unit: [
    {
      label: '円',
      value: 1,
      template: '.t_s_sel_waranty_fee3_unit1',
      athome: true,
    },
    {
      label: 'ヶ月',
      value: 2,
      template: '.t_s_sel_waranty_fee3_unit2',
      athome: true,
    },
    {
      label: '%',
      value: 3,
      template: '.t_s_sel_waranty_fee3_unit3',
      athome: true,
    },
  ],

  tax_waranty_fee3: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_tax_waranty_fee3_1',
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_tax_waranty_fee3_2',
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_tax_waranty_fee3_3',
    },
  ],
  f_insurance: [
    {
      label: '有',
      value: 1,
      template: '.t_r_f_insurance1',
    },
    {
      label: '無',
      value: 0,
      template: '.t_r_f_insurance0',
    },
  ],
  tax_insurance: [
    {
      label: '税込み',
      value: 1,
      template: '.t_s_1',
    },
    {
      label: '税抜き',
      value: 2,
      template: '.t_s_2',
    },
    {
      label: '非課税',
      value: 3,
      template: '.t_s_3',
    },
  ],
  transaction_form: [
    {
      label: '貸主',
      value: 1,
      template: '.t_s_transaction_form1',
      athome: true,
    },
    {
      label: '代理',
      value: 2,
      template: '.t_s_transaction_form2',
      athome: true,
    },
    {
      label: '一般媒介',
      value: 3,
      template: '.t_s_transaction_form3',
      athome: true,
    },
    {
      label: '専任媒介',
      value: 4,
      template: '.t_s_transaction_form4',
      athome: true,
    },
    {
      label: '先物',
      value: 5,
      template: '.t_s_transaction_form5',
      athome: true,
    },
    {
      label: '専属専任媒介',
      value: 6,
      template: '.t_s_transaction_form6',
      athome: true,
    },
  ],
  sel_futures_confirmation: [
    {
      label: 'TEL',
      value: 1,
      template: '.t_s_sel_futures_confirmation1',
    },
    {
      label: 'メール',
      value: 2,
      template: '.t_s_sel_futures_confirmation2',
    },
    {
      label: 'FAX',
      value: 3,
      template: '.t_s_sel_futures_confirmation3',
    },
    {
      label: 'WEB',
      value: 4,
      template: '.t_s_sel_futures_confirmation4',
    },
    {
      label: 'その他',
      value: 5,
      template: '.t_s_sel_futures_confirmation5',
    },
  ],
  customer_attache_no: [
    {
      label: '不可',
      value: 0,
      template: '.t_r_customer_attache_no0',
    },
    {
      label: '可',
      value: 1,
      template: '.t_r_customer_attache_no1',
    },
  ],
  homes_customer_classification: [
    {
      label: "HOME'S掲載可、他社HP掲載可、店頭紹介可",
      value: 1,
      template: '.t_s_homes_customer_classification1',
    },
    {
      label: '他社HP掲載可、店頭紹介可',
      value: 2,
      template: '.t_s_homes_customer_classification2',
    },
    {
      label: '店頭紹介可',
      value: 3,
      template: '.t_s_homes_customer_classification3',
    },
  ],

  reward_type: [
    {
      label: '分かれ',
      value: 1,
      template: '.t_s_reward_type1',
    },
    {
      label: '当方不払',
      value: 2,
      template: '.t_s_reward_type2',
    },
    {
      label: '当方全額',
      value: 3,
      template: '.t_s_reward_type3',
    },
    {
      label: '当方半額',
      value: 4,
      template: '.t_s_reward_type4',
    },
    {
      label: '貸主折半',
      value: 5,
      template: '.t_s_reward_type5',
    },
    {
      label: '借主折半',
      value: 6,
      template: '.t_s_reward_type6',
    },
    {
      label: '相談',
      value: 7,
      template: '.t_s_reward_type7',
    },
  ],
  unit_reward: [
    {
      label: 'ヶ月',
      value: 1,
    },
    {
      label: '円',
      value: 2,
    },
  ],
  unit_reward_button: [
    {
      label: '1ヶ月',
      value: 1,
      unitValue: 1,
      template: '.t_s_unit_reward1',
      athome: true,
    },
    {
      label: '2ヶ月',
      value: 2,
      unitValue: 1,
      template: '.t_s_unit_reward2',
      athome: true,
    },
    {
      label: '円',
      value: null,
      unitValue: 2,
      template: '.t_s_unit_reward',
      athome: true,
    },
  ],
  ad_reprinting: [
    {
      label: '転載可',
      value: 1,
      template: '.t_s_ad_reprinting1',
      athome: true,
    },
    {
      label: '要確認',
      value: 2,
      template: '.t_s_ad_reprinting2',
      athome: true,
    },
    {
      label: '転載不可',
      value: 3,
      template: '.t_s_ad_reprinting3',
      athome: true,
    },
  ],
  house_plan_clasmo: [
    {
      label: '1',
      value: 1,
    },
    {
      label: '2',
      value: 2,
    },
    {
      label: '3',
      value: 3,
    },
    {
      label: '4',
      value: 4,
    },
    {
      label: '5',
      value: 5,
    },
    {
      label: '6',
      value: 6,
    },
    {
      label: '7',
      value: 7,
    },
    {
      label: '8',
      value: 8,
    },
  ],
  house_plan: [
    {
      label: '1',
      value: 1,
    },
    {
      label: '2',
      value: 2,
    },
    {
      label: '3',
      value: 3,
    },
    {
      label: '4',
      value: 4,
    },
    {
      label: '5',
      value: 5,
    },
    {
      label: '6',
      value: 6,
    },
    {
      label: '7',
      value: 7,
    },
    {
      label: '8',
      value: 8,
    },
    {
      label: '9',
      value: 9,
    },
    {
      label: '10',
      value: 10,
    },
  ],
  house_plan_type: [
    {
      label: 'ワンルーム',
      value: 1,
    },
    {
      label: 'K',
      value: 2,
    },
    {
      label: 'DK',
      value: 3,
    },
    {
      label: 'LK',
      value: 4,
    },
    {
      label: 'LDK',
      value: 5,
    },
    {
      label: 'SK',
      value: 6,
    },
    {
      label: 'SDK',
      value: 7,
    },
    {
      label: 'SLK',
      value: 8,
    },
    {
      label: 'SLDK',
      value: 9,
    },
  ],
  house_plan_detail_type: [
    {
      label: '和室',
      value: 1,
      template: '.t_l_s_house_plan_detail option[valu,e="1"]',
    },
    {
      label: '洋室',
      value: 2,
      template: '.t_l_s_house_plan_detail option[valu,e="2"]',
    },
    {
      label: 'DK',
      value: 3,
      template: '.t_l_s_house_plan_detail option[valu,e="3"]',
    },
    {
      label: 'LDK',
      value: 4,
      template: '.t_l_s_house_plan_detail option[valu,e="4"]',
    },
    {
      label: 'LK',
      value: 5,
      template: '.t_l_s_house_plan_detail option[valu,e="5"]',
    },
    {
      label: 'LD',
      value: 6,
      template: '.t_l_s_house_plan_detail option[valu,e="6"]',
    },
    {
      label: 'L',
      value: 7,
      template: '.t_l_s_house_plan_detail option[valu,e="7"]',
    },
    {
      label: 'D',
      value: 8,
      template: '.t_l_s_house_plan_detail option[valu,e="8"]',
    },
    {
      label: 'K',
      value: 9,
      template: '.t_l_s_house_plan_detail option[valu,e="9"]',
    },
    {
      label: 'S',
      value: 10,
      template: '.t_l_s_house_plan_detail option[value,="10"]',
    },
    {
      label: 'その他',
      value: 11,
      template: '.t_l_s_house_plan_detail option[value,="11"]',
    },
  ],
  sel_initial_cost: [
    {
      label: '５万円以下',
      value: 1,
      template: '.t_s_sel_initial_cost1',
    },
    {
      label: '１０万円以下',
      value: 2,
      template: '.t_s_sel_initial_cost2',
    },
    {
      label: '1５万円以下',
      value: 3,
      template: '.t_s_sel_initial_cost3',
    },
    {
      label: '２０万円以下',
      value: 4,
      template: '.t_s_sel_initial_cost4',
    },
    {
      label: '３０万円以下',
      value: 5,
      template: '.t_s_sel_initial_cost5',
    },
  ],
  f_subsidized_rental: [
    {
      label: '有',
      value: 1,
      template: '.t_s_f_subsidized_rental1',
      suumoSearchItem: true,
    },
    {
      label: '無',
      value: 0,
      template: '.t_s_f_subsidized_rental0',
    },
  ],
  sel_rate_change_category: [
    {
      label: 'フラット型',
      value: 1,
      template: '.t_s_sel_rate_change_category1',
    },
    {
      label: '傾斜型',
      value: 2,
      template: '.t_s_sel_rate_change_category2',
    },
  ],

  sel_school_define: [
    {
      label: '限定',
      value: 1,
      template: '.t_s_sel_school_define1',
      athome: true,
    },
    {
      label: '歓迎',
      value: 2,
      template: '.t_s_sel_school_define2',
    },
    {
      label: '不可',
      value: 3,
      template: '.t_s_sel_school_define3',
    },
  ],
  sel_shikikin_student: [
    {
      label: '1ヶ月',
      value: 1,
      template: '.t_s_sel_shikikin_student1',
    },
    {
      label: '2ヶ月',
      value: 2,
      template: '.t_s_sel_shikikin_student2',
    },
  ],
  sel_single_define: [
    {
      label: '限定',
      value: 1,
      template: '.t_s_sel_single_define1',
    },
    {
      label: '希望',
      value: 2,
      template: '.t_s_sel_single_define2',
    },
    {
      label: '不可',
      value: 3,
      template: '.t_s_sel_single_define3',
    },
  ],
  sel_older_define: [
    {
      label: '限定',
      value: 1,
      template: '.t_s_sel_older_define1',
      suumoSearchItem: true,
      athome: true,
    },
    {
      label: '希望',
      value: 2,
      template: '.t_s_sel_older_define2',
      suumoSearchItem: true,
      athome: true,
    },
    {
      label: '不可',
      value: 3,
      template: '.t_s_sel_older_define3',
    },
    {
      label: '相談',
      value: 4,
      template: '.t_s_sel_older_define4',
    },
  ],
  sel_biz_define: [
    {
      label: '限定',
      value: 1,
      template: '.t_s_sel_biz_define1',
      athome: true,
    },
    {
      label: '希望',
      value: 2,
      template: '.t_s_sel_biz_define2',
      athome: true,
    },
    {
      label: '不可',
      value: 3,
      template: '.t_s_sel_biz_define3',
    },
  ],
  sel_pet_define: [
    {
      label: '対応',
      value: 1,
      template: '.t_s_sel_pet_define_1',
      suumoSearchItem: true,
      athome: true,
    },
    {
      label: '相談',
      value: 2,
      template: '.t_s_sel_pet_define_2',
      suumoSearchItem: true,
      athome: true,
    },
    {
      label: '不可',
      value: 3,
      template: '.t_s_sel_pet_define_3',
    },
  ],
  sel_roomshare_define: [
    {
      label: '対応',
      value: 1,
      template: '.t_s_sel_roomshare_define1',
      suumoSearchItem: true,
      athome: true,
    },
    {
      label: '相談',
      value: 2,
      template: '.t_s_sel_roomshare_define2',
    },
    {
      label: '不可',
      value: 3,
      template: '.t_s_sel_roomshare_define3',
    },
  ],
  sel_sex_define: [
    {
      label: '男性',
      value: 1,
      template: '.t_s_sel_sex_define1',
      athome: true,
    },
    {
      label: '女性',
      value: 2,
      template: '.t_s_sel_sex_define2',
      suumoSearchItem: true,
      athome: true,
    },
  ],
  sel_interphone_type: [
    {
      label: '音声',
      value: 1,
      template: '.t_s_sel_interphone_type1',
    },
    {
      label: 'TＶモニター付き',
      value: 2,
      template: '.t_s_sel_interphone_type2',
      suumoSearchItem: true,
      athome: true,
    },
  ],
  twowaylighting_way1: [
    {
      label: '北',
      value: 1,
    },
    {
      label: '北東',
      value: 2,
    },
    {
      label: '東',
      value: 3,
    },
    {
      label: '南東',
      value: 4,
    },
    {
      label: '南',
      value: 5,
    },
    {
      label: '南西',
      value: 6,
    },
    {
      label: '西',
      value: 7,
    },
    {
      label: '北西',
      value: 8,
    },
  ],
  twowaylighting_way2: [
    {
      label: '北',
      value: 1,
    },
    {
      label: '北東',
      value: 2,
    },
    {
      label: '東',
      value: 3,
    },
    {
      label: '南東',
      value: 4,
    },
    {
      label: '南',
      value: 5,
    },
    {
      label: '南西',
      value: 6,
    },
    {
      label: '西',
      value: 7,
    },
    {
      label: '北西',
      value: 8,
    },
  ],
  sel_southdirect_count: [
    {
      label: '2室',
      value: 1,
      template: '.t_s_sel_southdirect_count1',
    },
    {
      label: '3室',
      value: 2,
      template: '.t_s_sel_southdirect_count2',
    },
    {
      label: '4室',
      value: 3,
      template: '.t_s_sel_southdirect_count3',
    },
  ],
  sel_all_direction: [
    {
      label: '南向き',
      value: 1,
      template: '.t_s_sel_all_direction1',
    },
    {
      label: '東南向き',
      value: 2,
      template: '.t_s_sel_all_direction2',
    },
    {
      label: '南西向き',
      value: 3,
      template: '.t_s_sel_all_direction3',
    },
  ],
  sel_slidingshutter: [
    {
      label: '手動',
      value: 1,
      template: '.t_s_sel_slidingshutter1',
    },
    {
      label: '自動',
      value: 2,
      template: '.t_s_sel_slidingshutter2',
      athome: true,
    },
  ],
  sel_closet_count: [
    {
      label: '1',
      value: 1,
      template: '.t_s_sel_closet_count1',
    },
    {
      label: '2',
      value: 2,
      template: '.t_s_sel_closet_count2',
    },
    {
      label: '3',
      value: 3,
      template: '.t_s_sel_closet_count3',
    },
    {
      label: '4',
      value: 4,
      template: '.t_s_sel_closet_count4',
    },
  ],

  sel_walkincloset_count: [
    {
      label: '1',
      value: 1,
      template: '.t_s_walkincloset_count1',
    },
    {
      label: '2',
      value: 2,
      template: '.t_s_walkincloset_count2',
    },
    {
      label: '3',
      value: 3,
      template: '.t_s_walkincloset_count3',
    },
    {
      label: '4',
      value: 4,
      template: '.t_s_walkincloset_count4',
    },
  ],
  sel_bathtoilet_type: [
    {
      label: '別室',
      value: 1,
      template: '.t_s_sel_bathtoilet_type1',
      suumoSearchItem: true,
      athome: true,
    },
    {
      label: '同室',
      value: 2,
      template: '.t_s_sel_bathtoilet_type2',
      athome: true,
    },
    {
      label: 'トイレ',
      value: 3,
      template: '.t_s_sel_bathtoilet_type3',
      athome: true,
    },
    {
      label: '共同トイレ',
      value: 4,
      template: '.t_s_sel_bathtoilet_type4',
      athome: true,
    },
    {
      label: '共同バス',
      value: 5,
      template: 't_s_sel_bathtoilet_type5',
      athome: true,
    },
  ],
  sel_washingmachine_place: [
    {
      label: '室内',
      value: 1,
      template: '.t_s_sel_washingmachine_place1',
      suumoSearchItem: true,
      athome: true,
    },
    {
      label: '室外',
      value: 2,
      template: '.t_s_sel_washingmachine_place2',
    },
  ],
  sel_stove_count: [
    {
      label: '1',
      value: 1,
      template: '.t_s_sel_stove_count1',
      athome: true,
    },
    {
      label: '2',
      value: 2,
      template: '.t_s_sel_stove_count2',
      suumoSearchItem: true,
      athome: true,
    },
    {
      label: '3',
      value: 3,
      template: '.t_s_sel_stove_count3',
      suumoSearchItem: true,
      athome: true,
    },
    {
      label: '4',
      value: 4,
      template: '.t_s_sel_stove_count4',
      suumoSearchItem: true,
      athome: true,
    },
    {
      label: '5',
      value: 5,
      template: '.t_s_sel_stove_count5',
      suumoSearchItem: true,
      athome: true,
    },
    {
      label: '6',
      value: 6,
      template: '.t_s_sel_stove_count6',
      suumoSearchItem: true,
      athome: true,
    },
    {
      label: '7',
      value: 7,
      template: '.t_s_sel_stove_count7',
      suumoSearchItem: true,
      athome: true,
    },
    {
      label: '8',
      value: 8,
      template: '.t_s_sel_stove_count8',
      suumoSearchItem: true,
      athome: true,
    },
  ],
  sel_stove_type: [
    {
      label: '都市ガス',
      value: 1,
      template: '.t_s_sel_stove_type1',
      suumoSearchItem: true,
      athome: true,
    },
    {
      label: 'プロパン',
      value: 2,
      template: '.t_s_sel_stove_type2',
      suumoSearchItem: true,
      athome: true,
    },
    {
      label: '電気',
      value: 3,
      template: '.t_s_sel_stove_type3',
      athome: true,
    },
    {
      label: 'IH',
      value: 4,
      template: '.t_s_sel_stove_type4',
      suumoSearchItem: true,
      athome: true,
    },
  ],
  sel_waterfilter: [
    {
      label: '一体型',
      value: 1,
      template: '.t_s_sel_waterfilter1',
    },
    {
      label: '取付型',
      value: 2,
      template: '.t_s_sel_waterfilter1',
    },
  ],
  sel_airconditioner_count: [
    {
      label: '1',
      value: 1,
      template: '.t_s_airconditioner_count1',
      athome: true,
    },
    {
      label: '2',
      value: 2,
      template: '.t_s_airconditioner_count2',
      athome: true,
    },
    {
      label: '3',
      value: 3,
      template: '.t_s_airconditioner_count3',
      athome: true,
    },
    {
      label: '4',
      value: 4,
      template: '.t_s_airconditioner_count4',
      athome: true,
    },
    {
      label: '全室',
      value: 5,
      template: '.t_s_airconditioner_count5',
      athome: true,
    },
  ],
  sel_onlywarmer: [
    {
      label: 'ガス',
      value: 1,
      template: '.t_s_f_onlywarmer1',
    },
    {
      label: '石油',
      value: 2,
      template: '.t_s_f_onlywarmer2',
    },
  ],
  sel_catv_type: [
    {
      label: '無料',
      value: 1,
      template: '.t_s_sel_catv_type1',
    },
    {
      label: '有料',
      value: 2,
      template: '.t_s_sel_catv_type2',
    },
  ],
  sel_device: [
    {
      label: 'リコー(シータ)',
      value: 1,
      template: '.t_l_s_sel_panorama_room option[value="1"]',
    },
    {
      label: 'スマホパノラマ(iphone)',
      value: 2,
      template: '.t_l_s_sel_panorama_room option[value="2"]',
    },
    {
      label: 'スマホパノラマ（GalaxyS3）',
      value: 3,
      template: '.t_l_s_sel_panorama_room option[value="3"]',
    },
    {
      label: 'スマホパノラマ（GalaxyS4）',
      value: 4,
      template: '.t_l_s_sel_panorama_room option[value="4"]',
    },
    {
      label: 'ケンコーKDF-025',
      value: 5,
      template: '.t_l_s_sel_panorama_room option[value="5"]',
    },
    {
      label: 'ケンコーIDF-3',
      value: 6,
      template: '.t_l_s_sel_panorama_room option[value="6"]',
    },
  ],
  sel_estate_category: [
    {
      label: '建物外観',
      value: 1,
      template: '.t_l_s_sel_interior option[value="1"]',
    },
    {
      label: 'エントランス',
      value: 2,
      template: '.t_l_s_sel_interior option[value="2"]',
    },
    {
      label: 'ロビー',
      value: 3,
      template: '.t_l_s_sel_interior option[value="3"]',
    },
    {
      label: '駐車場',
      value: 4,
      template: '.t_l_s_sel_interior option[value="4"]',
    },
    {
      label: 'その他共有部分',
      value: 5,
      template: '.t_l_s_sel_interior option[value="5"]',
    },
    {
      label: '居室・リビング',
      value: 6,
      template: '.t_l_s_sel_interior option[value="6"]',
    },
    {
      label: 'その他部屋・スペース',
      value: 7,
      template: '.t_l_s_sel_interior option[value="7"]',
    },
    {
      label: 'キッチン',
      value: 8,
      template: '.t_l_s_sel_interior option[value="8"]',
    },
    {
      label: 'バス',
      value: 9,
      template: '.t_l_s_sel_interior option[value="9"]',
    },
    {
      label: 'トイレ',
      value: 10,
      template: '.t_l_s_sel_interior option[value="10"]',
    },
    {
      label: '洗面所',
      value: 11,
      template: '.t_l_s_sel_interior option[value="11"]',
    },
    {
      label: '収納',
      value: 12,
      template: '.t_l_s_sel_interior option[value="12"]',
    },

    {
      label: 'バルコニー',
      value: 13,
      template: '.t_l_s_sel_interior option[value="13"]',
    },
    {
      label: '庭',
      value: 14,
      template: '.t_l_s_sel_interior option[value="14"]',
    },
    {
      label: '玄関',
      value: 15,
      template: '.t_l_s_sel_interior option[value="15"]',
    },
    {
      label: 'セキュリティ',
      value: 16,
      template: '.t_l_s_sel_interior option[value="16"]',
    },
    {
      label: 'その他設備',
      value: 17,
      template: '.t_l_s_sel_interior option[value="17"]',
    },
    {
      label: '眺望',
      value: 18,
      template: '.t_l_s_sel_interior option[value="18"]',
    },
    {
      label: 'その他',
      value: 19,
      template: '.t_l_s_sel_interior option[value="19"]',
    },
    {
      label: '室内(ATBB専用)',
      value: 20,
      template: '.t_l_s_sel_interior option[value="20"]',
    },
    {
      label: '間取',
      value: 21,
      template: '.t_l_s_sel_interior option[value="21"]',
    },
    {
      label: '和室',
      value: 22,
      template: '.t_l_s_sel_interior option[value="22"]',
    },
    {
      label: '洋室',
      value: 23,
      template: '.t_l_s_sel_interior option[value="23"]',
    },
    {
      label: '子供部屋',
      value: 24,
      template: '.t_l_s_sel_interior option[value="24"]',
    },
    {
      label: '寝室',
      value: 25,
      template: '.t_l_s_sel_interior option[value="25"]',
    },
    {
      label: '内観',
      value: 26,
      template: '.t_l_s_sel_interior option[value="26"]',
    },
    {
      label: 'チラシ',
      value: 27,
      template: '.t_l_s_sel_interior option[value="27"]',
    },
  ],
  sel_estate_category_panorama: [
    {
      label: '洋室',
      value: 1,
      template: '.t_l_s_sel_panorama_room2 option[value="1"]',
    },
    {
      label: '和室',
      value: 2,
      template: '.t_l_s_sel_panorama_room2 option[value="2"]',
    },
    {
      label: 'リビング',
      value: 3,
      template: '.t_l_s_sel_panorama_room2 option[value="3"]',
    },
    {
      label: 'ダイニング',
      value: 4,
      template: '.t_l_s_sel_panorama_room2 option[value="4"]',
    },
    {
      label: 'キッチン',
      value: 5,
      template: '.t_l_s_sel_panorama_room2 option[value="5"]',
    },
    {
      label: '寝室',
      value: 6,
      template: '.t_l_s_sel_panorama_room2 option[value="6"]',
    },
    {
      label: '玄関',
      value: 7,
      template: '.t_l_s_sel_panorama_room2 option[value="7"]',
    },
    {
      label: 'トイレ',
      value: 8,
      template: '.t_l_s_sel_panorama_room2 option[value="8"]',
    },
    {
      label: 'バスルーム',
      value: 9,
      template: '.t_l_s_sel_panorama_room2 option[value="9"]',
    },
    {
      label: '収納',
      value: 10,
      template: '.t_l_s_sel_panorama_room2 option[value="10"]',
    },
    {
      label: 'ロフト',
      value: 11,
      template: '.t_l_s_sel_panorama_room2 option[value="11"]',
    },
    {
      label: 'バルコニー',
      value: 21,
      template: '.t_l_s_sel_panorama_room2 option[value="21"]',
    },

    {
      label: '外観',
      value: 22,
      template: '.t_l_s_sel_panorama_room2 option[value="22"]',
    },
    {
      label: 'エントランス',
      value: 23,
      template: '.t_l_s_sel_panorama_room2 option[value="23"]',
    },
    {
      label: '庭',
      value: 24,
      template: '.t_l_s_sel_panorama_room2 option[value="24"]',
    },
    {
      label: '屋上',
      value: 25,
      template: '.t_l_s_sel_panorama_room2 option[value="25"]',
    },
    {
      label: '倉庫',
      value: 26,
      template: '.t_l_s_sel_panorama_room2 option[value="26"]',
    },
    {
      label: '駐車場',
      value: 27,
      template: '.t_l_s_sel_panorama_room2 option[value="27"]',
    },
    {
      label: '周辺',
      value: 28,
      template: '.t_l_s_sel_panorama_room2 option[value="28"]',
    },
    {
      label: '洗面所',
      value: 29,
      template: '.t_l_s_sel_panorama_room2 option[value="29"]',
    },
    {
      label: '室内(その他)',
      value: 99,
      template: '.t_l_s_sel_panorama_room2 option[value="99"]',
    },
  ],
  sel_priority_image: [
    {
      label: '外観1',
      value: '外観1',
      property: 'exterior1_path',
    },
    {
      label: '外観2',
      value: '外観2',
      property: 'exterior2_path',
    },
    {
      label: '外観3',
      value: '外観3',
      property: 'exterior3_path',
    },
    {
      label: '地図',
      value: '地図',
      property: 'map_path',
    },
    {
      label: '周辺',
      value: '周辺',
      property: 'nearimage_path',
    },
    {
      label: '間取り',
      value: '間取り',
      property: 'house_plan_image',
    },
    {
      label: '内装1',
      value: '内装1',
      property: 'interior1_path',
    },
    {
      label: '内装2',
      value: '内装2',
      property: 'interior2_path',
    },
    {
      label: '内装3',
      value: '内装3',
      property: 'interior3_path',
    },
    {
      label: '内装4',
      value: '内装4',
      property: 'interior4_path',
    },
    {
      label: '内装5',
      value: '内装5',
      property: 'interior5_path',
    },
    {
      label: '内装6',
      value: '内装6',
      property: 'interior6_path',
    },
    {
      label: '内装7',
      value: '内装7',
      property: 'interior7_path',
    },
    {
      label: '内装8',
      value: '内装8',
      property: 'interior8_path',
    },
    {
      label: '内装9',
      value: '内装9',
      property: 'interior9_path',
    },
    {
      label: '内装10',
      value: '内装10',
      property: 'interior10_path',
    },
    {
      label: '内装11',
      value: '内装11',
      property: 'interior11_path',
    },
    {
      label: '内装12',
      value: '内装12',
      property: 'interior12_path',
    },
    {
      label: '内装13',
      value: '内装13',
      property: 'interior13_path',
    },
    {
      label: '内装14',
      value: '内装14',
      property: 'interior14_path',
    },
    {
      label: '内装15',
      value: '内装15',
      property: 'interior15_path',
    },
    {
      label: '内装16',
      value: '内装16',
      property: 'interior16_path',
    },
    {
      label: '内装17',
      value: '内装17',
      property: 'interior17_path',
    },
    {
      label: '内装18',
      value: '内装18',
      property: 'interior18_path',
    },
    {
      label: '内装19',
      value: '内装19',
      property: 'interior19_path',
    },
    {
      label: '内装20',
      value: '内装20',
      property: 'interior20_path',
    },
    {
      label: '内装21',
      value: '内装21',
      property: 'interior21_path',
    },
    {
      label: '内装22',
      value: '内装22',
      property: 'interior22_path',
    },
    {
      label: '内装23',
      value: '内装23',
      property: 'interior23_path',
    },
    {
      label: '内装24',
      value: '内装24',
      property: 'interior24_path',
    },
    {
      label: '内装25',
      value: '内装25',
      property: 'interior25_path',
    },
    {
      label: '内装26',
      value: '内装26',
      property: 'interior26_path',
    },
    {
      label: '内装27',
      value: '内装27',
      property: 'interior27_path',
    },
    {
      label: '内装28',
      value: '内装28',
      property: 'interior28_path',
    },
    {
      label: '内装29',
      value: '内装29',
      property: 'interior29_path',
    },
    {
      label: '内装30',
      value: '内装30',
      property: 'interior30_path',
    },
  ],
  mynavi_charge_id: [
    {
      label: '1',
      value: 1,
    },
    {
      label: '2',
      value: 2,
    },
    {
      label: '3',
      value: 3,
    },
    {
      label: '4',
      value: 4,
    },
    {
      label: '5',
      value: 5,
    },
    {
      label: '6',
      value: 6,
    },
    {
      label: '7',
      value: 7,
    },
    {
      label: '8',
      value: 8,
    },
    {
      label: '9',
      value: 9,
    },
  ],
  rengotai_corner: [
    {
      label: '指定なし',
      value: 0,
    },
    {
      label: '1',
      value: 1,
    },
    {
      label: '2',
      value: 2,
    },
    {
      label: '3',
      value: 3,
    },
    {
      label: '4',
      value: 4,
    },
    {
      label: '5',
      value: 5,
    },
    {
      label: '6',
      value: 6,
    },
    {
      label: '7',
      value: 7,
    },
    {
      label: '8',
      value: 8,
    },
    {
      label: '9',
      value: 9,
    },
    {
      label: '10',
      value: 10,
    },
    {
      label: '11',
      value: 11,
    },
    {
      label: '12',
      value: 12,
    },
    {
      label: '13',
      value: 13,
    },
    {
      label: '14',
      value: 14,
    },
    {
      label: '15',
      value: 15,
    },
    {
      label: '16',
      value: 16,
    },
    {
      label: '17',
      value: 17,
    },
    {
      label: '18',
      value: 18,
    },
    {
      label: '19',
      value: 19,
    },
    {
      label: '20',
      value: 20,
    },
    {
      label: '21',
      value: 21,
    },
    {
      label: '22',
      value: 22,
    },
    {
      label: '23',
      value: 23,
    },
    {
      label: '24',
      value: 24,
    },
    {
      label: '25',
      value: 25,
    },
    {
      label: '26',
      value: 26,
    },
    {
      label: '27',
      value: 27,
    },
    {
      label: '28',
      value: 28,
    },
    {
      label: '29',
      value: 29,
    },
    {
      label: '30',
      value: 30,
    },
  ],
  mynavi_charge_id_shop: [
    {
      label: '1',
      value: 1,
    },
    {
      label: '2',
      value: 2,
    },
    {
      label: '3',
      value: 3,
    },
    {
      label: '4',
      value: 4,
    },
    {
      label: '5',
      value: 5,
    },
    {
      label: '6',
      value: 6,
    },
    {
      label: '7',
      value: 7,
    },
    {
      label: '8',
      value: 8,
    },
    {
      label: '9',
      value: 9,
    },
  ],
  rengotai_corner_shop: [
    {
      label: '指定なし',
      value: 0,
    },
    {
      label: '1',
      value: 1,
    },
    {
      label: '2',
      value: 2,
    },
    {
      label: '3',
      value: 3,
    },
    {
      label: '4',
      value: 4,
    },
    {
      label: '5',
      value: 5,
    },
    {
      label: '6',
      value: 6,
    },
    {
      label: '7',
      value: 7,
    },
    {
      label: '8',
      value: 8,
    },
    {
      label: '9',
      value: 9,
    },
    {
      label: '10',
      value: 10,
    },
    {
      label: '11',
      value: 11,
    },
    {
      label: '12',
      value: 12,
    },
    {
      label: '13',
      value: 13,
    },
    {
      label: '14',
      value: 14,
    },
    {
      label: '15',
      value: 15,
    },
    {
      label: '16',
      value: 16,
    },
    {
      label: '17',
      value: 17,
    },
    {
      label: '18',
      value: 18,
    },
    {
      label: '19',
      value: 19,
    },
    {
      label: '20',
      value: 20,
    },
    {
      label: '21',
      value: 21,
    },
    {
      label: '22',
      value: 22,
    },
    {
      label: '23',
      value: 23,
    },
    {
      label: '24',
      value: 24,
    },
    {
      label: '25',
      value: 25,
    },
    {
      label: '26',
      value: 26,
    },
    {
      label: '27',
      value: 27,
    },
    {
      label: '28',
      value: 28,
    },
    {
      label: '29',
      value: 29,
    },
    {
      label: '30',
      value: 30,
    },
  ],
  prking_exist: [
    {
      label: '有',
      value: 1,
    },
    {
      label: '無',
      value: 2,
    },
    {
      label: '空無',
      value: 3,
    },
    {
      label: '近隣',
      value: 4,
    },
  ],
  parking_type: [
    {
      label: '駐2台可',
      value: 1,
    },
    {
      label: '駐3台可',
      value: 2,
    },
    {
      label: '駐2台付',
      value: 3,
    },
    {
      label: '駐3台付',
      value: 4,
    },
    {
      label: '地下駐',
      value: 5,
    },
    {
      label: '地下車庫',
      value: 6,
    },
    {
      label: '屋根付駐',
      value: 7,
    },
    {
      label: '平置屋根付駐',
      value: 8,
    },
    {
      label: '機械式屋根付駐',
      value: 9,
    },
    {
      label: '屋内駐',
      value: 10,
    },
    {
      label: '平置駐',
      value: 11,
    },
    {
      label: 'シャッタ付車庫',
      value: 12,
    },
    {
      label: 'シャッタ付地下車庫',
      value: 13,
    },
    {
      label: 'シャッタ付屋内駐',
      value: 14,
    },
    {
      label: 'シャッタ付駐',
      value: 15,
    },
    {
      label: 'リモコンシャッタ付地下駐',
      value: 16,
    },

    {
      label: 'リモコンシャッタ付駐',
      value: 17,
    },
    {
      label: '砂利引き',
      value: 18,
    },
    {
      label: '舗装',
      value: 19,
    },
    {
      label: '舗装屋根',
      value: 20,
    },
    {
      label: '簡易舗装',
      value: 21,
    },
    {
      label: '機械式',
      value: 22,
    },
    {
      label: 'タワー',
      value: 23,
    },
    {
      label: '自走式タワー',
      value: 24,
    },
  ],
  company_private_traders: [
    {
      label: '個人',
      value: 1,
    },
    {
      label: '法人',
      value: 2,
    },
  ],
  sel_account_type: [
    {
      label: '普通',
      value: 1,
    },
    {
      label: '当座',
      value: 2,
    },
  ],
  insurance_fee_method: [
    {
      label: '代理店',
      value: 1,
    },
    {
      label: '口座振替',
      value: 2,
    },
    {
      label: 'クレジットカード',
      value: 3,
    },
    {
      label: '新規コンビニ',
      value: 4,
    },
  ],
  insurance_term: [
    {
      label: '1年',
      value: 1,
    },
    {
      label: '2年',
      value: 2,
    },
    {
      label: '月払',
      value: 3,
    },
  ],
  insurance_bank_type: [
    {
      label: 'ゆうちょ以外の銀行',
      value: 1,
    },
    {
      label: 'ゆうちょ',
      value: 2,
    },
  ],
  insurance_deposit_type: [
    {
      label: '普通',
      value: 1,
    },
    {
      label: '当座',
      value: 2,
    },
  ],
  f_else_insurance_contract_our: [
    {
      label: '無',
      value: 0,
    },
    {
      label: '有',
      value: 1,
    },
  ],
  f_else_insurance_contract_else: [
    {
      label: '無',
      value: 0,
    },
    {
      label: '有',
      value: 1,
    },
  ],
  f_else_insurance_require_doc: [
    {
      label: '無',
      value: 0,
    },
    {
      label: '有',
      value: 1,
    },
  ],
  insurance_join_cource: {
    1: [
      {
        label: '1年6,500円コース',
        value: 1,
      },
      {
        label: '1年7,500円コース',
        value: 2,
      },
      {
        label: '1年8,000円コース',
        value: 3,
      },
      {
        label: '1年8,500円コース',
        value: 4,
      },
      {
        label: '1年9,500円コース',
        value: 5,
      },
      {
        label: '1年10,000円コース',
        value: 6,
      },
      {
        label: '1年10,500円コース',
        value: 7,
      },
      {
        label: '1年11,000円コース',
        value: 8,
      },
      {
        label: '1年12,000円コース',
        value: 9,
      },
      {
        label: '1年13,000円コース',
        value: 10,
      },
      {
        label: '1年14,000円コース',
        value: 11,
      },
      {
        label: '1年15,000円コース',
        value: 12,
      },
    ],
    2: [
      {
        label: '2年10,000円コース',
        value: 13,
      },
      {
        label: '2年12,000円コース',
        value: 14,
      },
      {
        label: '2年14,000円コース',
        value: 15,
      },
      {
        label: '2年15,000円コース',
        value: 16,
      },
      {
        label: '2年16,000円コース',
        value: 17,
      },
      {
        label: '2年18,000円コース',
        value: 18,
      },
      {
        label: '2年19,000円コース',
        value: 19,
      },
      {
        label: '2年20,000円コース',
        value: 20,
      },
      {
        label: '2年21,000円コース',
        value: 21,
      },
      {
        label: '2年23,000円コース',
        value: 22,
      },
      {
        label: '2年25,000円コース',
        value: 23,
      },
      {
        label: '2年27,000円コース',
        value: 24,
      },
      {
        label: '2年29,000円コース',
        value: 25,
      },
    ],
    3: [
      {
        label: '月払550円コース',
        value: 26,
      },
      {
        label: '月払630円コース',
        value: 27,
      },
      {
        label: '月払720円コース',
        value: 28,
      },
      {
        label: '月払760円コース',
        value: 29,
      },
      {
        label: '月払800円コース',
        value: 30,
      },
      {
        label: '月払890円コース',
        value: 31,
      },
      {
        label: '月払930円コース',
        value: 32,
      },
      {
        label: '月払970円コース',
        value: 33,
      },
      {
        label: '月払1,010円コース',
        value: 34,
      },
      {
        label: '月払1,100円コース',
        value: 35,
      },
      {
        label: '月払1,180円コース',
        value: 36,
      },
      {
        label: '月払1,260円コース',
        value: 37,
      },
      {
        label: '月払1,350円コース',
        value: 38,
      },
    ],
  },
  f_target_flag_ksk: [
    {
      label: '貸主',
      value: 1,
    },
    {
      label: '書類送付先',
      value: 2,
    },
  ],
  sel_waranty_unit: [
    {
      label: '円',
      value: 1,
    },
    {
      label: 'ヶ月',
      value: 2,
    },
    {
      label: '%',
      value: 3,
    },
  ],
  sel_waranty_tax: [
    {
      label: '税込み',
      value: 1,
    },
    {
      label: '税抜き',
      value: 2,
    },
    {
      label: '非課税',
      value: 3,
    },
  ],
  keymapping_catch_b: {
    f_station5_b_catch: '駅徒歩５分以内',
    f_newold_b_catch: '新築',
    f_floor20_b_catch: '階建２０階以上',
    f_parking_b_catch: '駐車場有',
    f_nearparking_b_catch: '駐車場近隣',
    f_elevator_b_catch: 'エレベーター',
    f_twentyfourcare_b_catch: '24時間緊急対応',
    f_securitycamera_b_catch: '防犯カメラ',
    f_garbage24_b_catch: '24Hゴミ出し可',
    f_homedeliverybox_b_catch: '宅配ボックス',
  },

  keymapping_catch_bc: {
    f_station5_bc_catch: '駅徒歩５分以内',
    f_newold_bc_catch: '新築',
    f_floor20_bc_catch: '階建２０階以上',
    f_parking_bc_catch: '駐車場有',
    f_nearparking_bc_catch: '駐車場近隣',
    f_elevator_bc_catch: 'エレベーター',
    f_topfloor_bc_catch: '階建＝所在階',
    f_freerent_bc_catch: 'フリーレント',
    f_pet1_bc_catch: 'ペット対応',
    f_pet2_bc_catch: 'ペット相談',
    f_business_bc_catch: '事務所可',
    f_sex2_bc_catch: '性別女性',
    f_twentyfourcare_bc_catch: '24時間緊急対応',
    f_securitycamera_bc_catch_bc_catch: '防犯カメラ',
    f_fingerprintauth_bc_catch: '指紋認証',
    f_veinauth_bc_catch: '静脈認証',
    f_cardkey_bc_catch: 'カードキー',
    f_electrickey_bc_catch: '電子キー',
    f_electriclock_bc_catch: '電子ロック',
    f_autolock_bc_catch: 'オートロック',
    f_securityshutter_bc_catch: '防犯シャッター',
    f_securityglass_bc_catch: '防犯ガラス',
    f_garbage24_bc_catch: '24Hゴミ出し可',
    f_homedeliverybox_bc_catch: '宅配ボックス',
    f_athleticgym_bc_catch: '共用アスレチック',
    f_pool_bc_catch: '共用プール',
    f_kidsroom_bc_catch: '共用キッズルーム',
    f_coinlaundry_bc_catch: '共用コインランドリー',
    f_theater_bc_catch: '共用シアタールーム',
    f_publicbath_bc_catch: '共用大浴場',
    f_cornerroom_bc_catch: '角部屋',
    f_designers_bc_catch: 'デザイナーズ',
    f_flooring_bc_catch: 'フローリング',
    f_loft_bc_catch: 'ロフト',
    f_bed_bc_catch: 'ベッド付き',
    f_bathtoiletsep_bc_catch: 'バストイレ別',
    f_humansensor_bc_catch: '人感センサー',
    f_dimple_bc_catch: 'ディンプルキー',
    f_doublelock_bc_catch: 'ダブルロック',
    f_firealarm_bc_catch: '火災報知器',
    f_impedimentremoval_bc_catch: 'バリアフリー',
    f_maisonette_bc_catch: 'メゾネット',
    f_blind_bc_catch: 'ブラインド',
    f_lighting_bc_catch: '照明機器',
    f_curtain_bc_catch: 'カーテン付',
    f_furniture_bc_catch: '家具付',
    f_terrace_bc_catch: 'テラス',
    f_roofbalcony_bc_catch: 'ルーフバルコニー',
    f_privategarden_bc_catch: '専用庭',
    f_middlegarden_bc_catch: '中庭',
    f_walkincloset_bc_catch: 'ウォークインクロゼット',
    f_shosewalkincloset_bc_catch: 'シューズインクロゼット',
    f_trunkroom_bc_catch: 'トランクルーム',
    f_additionalbatch_bc_catch: '追い焚き',
    f_dehumidifierbathroom_bc_catch: '浴室乾燥機',
    f_autobath_bc_catch: 'オートバス',
    f_ontvpath_bc_catch: 'TV付バス',
    f_mistsauna_bc_catch: 'ミストサウナ',
    f_washlet_bc_catch: '温水洗浄便座',
    f_tunklesstoilet_bc_catch: 'タンクレストイレ',
    f_shampoodresser_bc_catch: 'シャンプードレッサー',
    f_washingmachine_bc_catch: '洗濯機付',
    f_waterfilter_bc_catch: '浄水器',
    f_dishwashingdryer_bc_catch: '食器洗乾燥機',
    f_refrigerator_bc_catch: '冷蔵庫付',
    f_floorheating_bc_catch: '床暖房',
    f_builtinairconditioner_bc_catch: 'ビルトインエアコン',
    f_floor20_cornerroom_bc_catch: '階建20階以上＋角部屋',
    f_bs_cs_bc_catch: 'BS＋CS',
  },
  sel_type1: [
    {
      label: '賃貸住居用',
      value: 1,
    },
    {
      label: '賃貸事業用土地建物',
      value: 2,
    },
    {
      label: '賃貸事業用建物一部',
      value: 3,
    },
    {
      label: '賃貸駐車場',
      value: 4,
    },
  ],

  sel_type2: {
    1: [
      {
        label: 'マンション(賃貸住居用)',
        value: 1,
      },
      {
        label: 'テラスハウス(賃貸住居用)',
        value: 2,
      },
      {
        label: 'タウンハウス(賃貸住居用)',
        value: 3,
      },
      {
        label: 'アパート(賃貸住居用)',
        value: 4,
      },
      {
        label: '一戸建(賃貸住居用)',
        value: 5,
      },
    ],
    2: [
      {
        label: '店舗',
        value: 1,
      },
      {
        label: 'ビル',
        value: 2,
      },
      {
        label: '工場',
        value: 3,
      },
      {
        label: 'マンション',
        value: 4,
      },
      {
        label: '倉庫',
        value: 5,
      },
      {
        label: 'アパート',
        value: 6,
      },
      {
        label: '寮',
        value: 7,
      },
      {
        label: '土地',
        value: 8,
      },
      {
        label: 'その他',
        value: 9,
      },
      {
        label: '事務所用',
        value: 10,
      },
      {
        label: '店舗事務所用',
        value: 11,
      },
    ],
    3: [
      {
        label: '店舗用',
        value: 1,
      },
      {
        label: '事務所用',
        value: 2,
      },
      {
        label: '店舗事務所用',
        value: 3,
      },
    ],
    4: [
      {
        label: '駐車場',
        value: 1,
      },
    ],
  },
  neighbor_select: [
    {
      label: 'ショッピングセンター',
      value: 2,
      template: '.t_l_s_near_select option[value="2"]',
    },
    {
      label: 'スーパー',
      value: 3,
      template: '.t_l_s_near_select option[value="3"]',
    },
    {
      label: 'コンビニ',
      value: 4,
      template: '.t_l_s_near_select option[value="4"]',
    },
    {
      label: 'ドラッグストア',
      value: 5,
      template: '.t_l_s_near_select option[value="5"]',
    },
    {
      label: 'ホームセンター',
      value: 6,
      template: '.t_l_s_near_select option[value="6"]',
    },
    {
      label: '大学',
      value: 7,
      template: '.t_l_s_near_select option[value="7"]',
    },
    {
      label: '高校',
      value: 8,
      template: '.t_l_s_near_select option[value="8"]',
    },
    {
      label: '中学校',
      value: 9,
      template: '.t_l_s_near_select option[value="9"]',
    },
    {
      label: '小学校',
      value: 10,
      template: '.t_l_s_near_select option[value="10"]',
    },
    {
      label: '幼稚園・保育園',
      value: 11,
      template: '.t_l_s_near_select option[value="11"]',
    },
    {
      label: 'その他学校',
      value: 12,
      template: '.t_l_s_near_select option[value="12"]',
    },
    {
      label: '病院',
      value: 13,
      template: '.t_l_s_near_select option[value="13"]',
    },
    {
      label: '郵便局',
      value: 14,
      template: '.t_l_s_near_select option[value="14"]',
    },
    {
      label: '役所',
      value: 15,
      template: '.t_l_s_near_select option[value="15"]',
    },
    {
      label: '図書館',
      value: 16,
      template: '.t_l_s_near_select option[value="16"]',
    },
    {
      label: '銀行',
      value: 17,
      template: '.t_l_s_near_select option[value="17"]',
    },
    {
      label: '警察署',
      value: 18,
      template: '.t_l_s_near_select option[value="18"]',
    },
    {
      label: '公園',
      value: 19,
      template: '.t_l_s_near_select option[value="19"]',
    },
    {
      label: '飲食店',
      value: 20,
      template: '.t_l_s_near_select option[value="20"]',
    },
    {
      label: 'レンタルビデオ',
      value: 21,
      template: '.t_l_s_near_select option[value="21"]',
    },
    {
      label: 'その他',
      value: 22,
      template: '.t_l_s_near_select option[value="22"]',
    },
  ],
  sel_renewable_energy_equipment: [
    {
      label: '有',
      value: 1,
    },
    {
      label: '無',
      value: 0,
    },
  ],
  sel_insulation_performance: [
    {
      label: '1',
      value: 1,
    },
    {
      label: '2',
      value: 2,
    },
    {
      label: '3',
      value: 3,
    },
    {
      label: '4',
      value: 4,
    },
    {
      label: '5',
      value: 5,
    },
    {
      label: '6',
      value: 6,
    },
    {
      label: '7',
      value: 7,
    },
  ],
  sel_key_place: [
    {
      label: '現地',
      value: 1,
      athome: true,
    },
    {
      label: '預託会社',
      value: 2,
      athome: true,
    },
    {
      label: '自社',
      value: 3,
      athome: true,
    },
    {
      label: 'その他',
      value: 4,
      athome: true,
    },
  ],
  sel_bathhotwater_type: [
    { label: 'ガス釜', value: 1, template: '.t_s_sel_bathhotwater_type1' },
    { label: '灯油釜', value: 2, template: '.t_s_sel_bathhotwater_type2' },
  ],
  sel_ventilation_type: [
    { label: '熱交換型（ロスナイ等）', value: 1, template: '.t_s_sel_ventilation_type1' },
    { label: '強制排気型', value: 2, template: '.t_s_sel_ventilation_type2' },
  ],
  sel_gaspiping: [
    { label: '有', value: 1, template: '.t_s_sel_gaspiping1' },
    { label: '無', value: 0, template: '.t_s_sel_gaspiping0' },
  ],
  sel_kerosenepiping: [
    { label: '有', value: 1, template: '.t_s_sel_kerosenepiping1' },
    { label: '無', value: 0, template: '.t_s_sel_kerosenepiping0' },
  ],
  sel_kerosenepipingtank_type: [
    { label: '個別', value: 1, template: '.t_s_sel_kerosenepipingtank_type1' },
    { label: '集中', value: 2, template: '.t_s_sel_kerosenepipingtank_type2' },
    { label: '共用', value: 3, template: '.t_s_sel_kerosenepipingtank_type3' },
  ],
  sel_kerosenetank: [
    { label: '90L', value: 1, template: '.t_s_sel_kerosenetank1' },
    { label: '180L', value: 2, template: '.t_s_sel_kerosenetank2' },
    { label: '490L', value: 3, template: '.t_s_sel_kerosenetank3' },
    { label: 'メーター', value: 4, template: '.t_s_sel_kerosenetank4' },
    { label: 'その他', value: 5, template: '.t_s_sel_kerosenetank5' },
  ],
  sel_cleaning_status: [
    {
      label: '清掃前',
      value: 1,
      athome: true,
    },
    {
      label: '清掃中',
      value: 2,
      athome: true,
    },
  ],
  sel_publication_range: [
    {
      label: '全公開',
      value: 1,
    },
    {
      label: '自社+特定業者',
      value: 2,
    },
    {
      label: '自社のみ',
      value: 3,
    },
  ],
  sel_web_application_reception: [
    {
      label: '可能',
      value: 1,
    },
    {
      label: '不可能',
      value: 2,
    },
  ],
  sel_internet_fee: [
    {
      label: '有料',
      value: 2,
    },
    {
      label: '無料',
      value: 1,
    },
  ],
}
